const Getters = {
  getPlatformListFromState: (state) => {
    return state.platformList
  },
  getMaxSortNumber: (state) => {
    return state.maxSortNumber
  }
}

export default Getters
